import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

export function initGLightbox() {
    const triggers = document.querySelectorAll('.js-glightbox-trigger');
    
    if (triggers.length === 0) return;

    let activeLightbox = null;

    // Handle close button - use touchend to prevent iOS ghost clicks
    const handleClose = (e) => {
        const closeButton = e.target.closest('.glightbox-container .js-glightbox-close');
        if (closeButton && activeLightbox) {
            e.preventDefault();
            e.stopPropagation();
            activeLightbox.close();
        }
    };

    // touchend with preventDefault stops iOS from generating a synthetic click
    document.addEventListener('touchend', handleClose);
    document.addEventListener('click', handleClose);

    // Add click event to each trigger
    triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            
            // Find the parent contact card
            const card = trigger.closest('.js-contact-card');
            if (!card) return;
            
            // Find the hidden content container
            const hiddenContent = card.querySelector('.js-lightbox-content');
            if (!hiddenContent) return;
            
            // Get the complete HTML content from the view
            const content = hiddenContent.innerHTML;
            
            // Initialize and open GLightbox with the pre-rendered content
            activeLightbox = GLightbox({
                elements: [
                    {
                        content: content,
                        width: 'auto'
                    }
                ],
                autoplayVideos: false,
                width: 'auto',
                height: 'auto',
                loop: false,
                touchNavigation: false,
                keyboardNavigation: true,
                closeOnOutsideClick: true,
                skin: 'contact-card'
            });

            activeLightbox.on('close', () => {
                activeLightbox = null;
            });
            
            activeLightbox.open();
        });
    });
}
